/*
 * Find subheadings on a page, add them to the page-headings nav el, and highlight the current one as the page scrolls
 */

const subheadings = document.querySelectorAll("main article h2");
const sidebar = document.querySelector("main nav.page-headings");

function addSubheadingsToSidebar() {
  // Get DOM elements needed for detection
  if (!sidebar || subheadings.length === 0) return;
  // Iterate through subheadings
  sidebar.removeAttribute("hidden");
  const listEl = sidebar.querySelector("ul");
  subheadings.forEach((subheading) => {
    const li = document.createElement("li");
    // Create link el
    const link = document.createElement("a");
    link.innerText = subheading.innerText;
    link.setAttribute("href", "#");
    link.addEventListener("click", (e) => {
      e.preventDefault();
      subheading.scrollIntoView();
    });
    li.appendChild(link);
    listEl.appendChild(li);
  });
}

// Function to check if an element is in the viewport
function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= window.innerHeight - window.innerHeight / 1.7 &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// Function to find the highest h2 tag in view
function findHighestSubheadingInView() {
  let highestInView = null;
  let highestOffsetTop = -Infinity;

  for (const h2 of subheadings) {
    if (isElementInViewport(h2)) {
      const offsetTop = h2.offsetTop;
      if (offsetTop > highestOffsetTop) {
        highestOffsetTop = offsetTop;
        highestInView = h2;
      }
    }
  }

  return highestInView;
}

function markCurrentSubheading() {
  if (!sidebar || subheadings.length === 0) return;
  const highestH2InView = findHighestSubheadingInView();
  if (!highestH2InView) return;
  const sidebarLinks = sidebar.querySelectorAll("li a");
  sidebarLinks.forEach((linkEl) => {
    linkEl.classList.remove("current");
    if (linkEl.innerText === highestH2InView.innerText) {
      linkEl.classList.add("current");
    }
  });
}

export { addSubheadingsToSidebar, markCurrentSubheading };
